import { useTranslation } from "react-i18next"

import ConnectPaymentMethodLayout from "../../../layouts/ConnectPaymentMethodLayout"
import { PaymentEngagementType } from "../../../enums"

import { AchFteSetupSteps } from "./components/AchFteSetupSteps"
import { AchContractorSetupSteps } from "./components/AchContractorSetupSteps"

interface AchLandingPageProps {
  type: PaymentEngagementType
}
const AchLandingPage = ({ type }: AchLandingPageProps) => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/AchLandingPage")

  return (
    <ConnectPaymentMethodLayout title={t("title")} subtitle={t("subtitle")}>
      <div className="relative w-[720px] rounded-lg border-2 border-gray-200 bg-white p-2 text-left md:p-8">
        {type === PaymentEngagementType.Fte ? (
          <AchFteSetupSteps />
        ) : (
          <AchContractorSetupSteps type={type} />
        )}
      </div>
    </ConnectPaymentMethodLayout>
  )
}

export default AchLandingPage
